import { call, select, takeEvery } from 'redux-saga/effects';
import { GlobalActions, GlobalPut, storeIsAvailable } from '@ps20-frontend/shop-integration-redux';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { PS20Logger } from '@ps20-frontend/logging';
import { App, isMultistoreApp } from '@ps20-frontend/frontend-models';
import { IAppState } from '../appState';
import { angebotIsTarifiert } from '../selectors/warenkorb.selector';

export function* appIdsInWarenkorbProviderSaga() {
  yield takeEvery(
    GlobalActions.ANGEBOTE_IN_WARENKORB_REQUESTED,
    safeSaga(provideAngeboteInWarenkorb, App.SHOP_DASHBOARD),
  );
}

export function* provideAngeboteInWarenkorb() {
  const state: IAppState = yield select();
  const angebote = state.warenkorb
    .filter(produkt => angebotIsTarifiert(produkt))
    .map(produkt => ({
      appId: produkt.appId,
      angebotsId: produkt.angebotsId,
    }));
  const angeboteWithoutStore = angebote.filter(
    angebot => isMultistoreApp(angebot.appId) && !storeIsAvailable(angebot),
  );
  if (angeboteWithoutStore.length > 0) {
    PS20Logger.info(
      'provideAngeboteInWarenkorb.angeboteWithoutStoreSkipped',
      JSON.stringify(angeboteWithoutStore),
      App.SHOP_DASHBOARD,
    );
  }
  const tarifierteAngebote = angebote.filter(angebot => !angeboteWithoutStore.includes(angebot));
  const globalPut = GlobalPut.getInstance();

  yield call(globalPut.put, new GlobalActions().provideAngeboteInWarenkorb(tarifierteAngebote));
}
